import { IMultiLang } from '../_types'
import { resolveLocaleField } from './resolve-locale-field'

export function getMultiLangText(
  value: Partial<IMultiLang> | string | undefined | null,
  locale: string,
  fallback = ''
): string {
  if (!value) return fallback
  if (typeof value === 'string') return value

  return resolveLocaleField(value as Record<string, string>, locale, [], fallback)
}
